import React, { useState, useEffect } from 'react'
import './style.scss'

import i18n from 'live/services/i18n'
import styled from 'styled-components'
import FilterDropdown from 'live/components/forms/ui/filter-dropdown'
import { Lookup } from '../../DrillDownMap'

type Props = {
    lookups: Lookup[]
    callback(lookup: Lookup): void
}

const DropdownReferenceLine = ({ lookups, callback }: Props): JSX.Element => {
    const [referenceLine, setReferenceLine] = useState<Lookup>()

    const applyReferenceLine = (referenceLine): void => {
        setReferenceLine(referenceLine)
        callback(referenceLine)
    }

    useEffect(() => {
        const lookupsNotHasReferenceLine = referenceLine && !lookups.find(ele => ele.key === referenceLine.key)

        if (lookupsNotHasReferenceLine) setReferenceLine(undefined)
    }, [lookups]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <FilterDropdown
            hideTitle={true}
            disableTooltip={true}
            containerClassName="smart-mobility-dropdown-reference-line"
            btnLabel={
                <WrapperBtn>
                    <span className="wrapper-btn-title">{i18n('On map')}:</span>
                    <span data-testid="reference-line-active" className="wrapper-btn-reference-line">
                        {referenceLine ? referenceLine.key : i18n('Reference Line')}
                    </span>
                    <i className="fas fa-caret-down"></i>
                </WrapperBtn>
            }
        >
            <Wrapper>
                <LookupItem onClick={() => applyReferenceLine(null)}>{i18n('Reference Line')}</LookupItem>

                {lookups.map((lookup, index) => {
                    const { key } = lookup

                    return (
                        <LookupItem
                            data-testid={'teste-reference-line-' + index}
                            key={index}
                            onClick={() => applyReferenceLine(lookup)}
                        >
                            {key}
                        </LookupItem>
                    )
                })}
            </Wrapper>
        </FilterDropdown>
    )
}

export default DropdownReferenceLine

const Wrapper = styled.div``

const WrapperBtn = styled.div`
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;

    .wrapper-btn-title {
        color: ${({ theme }) => theme['gray-600']};
        margin-right: 8px;
    }

    .wrapper-btn-reference-line {
        margin-right: 8px;
    }

    .wrapper-btn-reference-line,
    i {
        color: ${({ theme }) => theme['blue-500']};
    }
`

const LookupItem = styled.div`
    cursor: pointer;
    font-size: 13px;
    padding: 12px 16px;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-700']};

    &:hover {
        background-color: ${({ theme }) => theme['blue-200']};
    }
`
